export default {
  // need check if this fields are necessary
  newQuestion: null,
  updatedProfileData: null,
  selectedQuestion: null,
  surveyDetails: null,
  selectedFeatures: [],
  addedConsentSection: null,
  addedOptionalConsentSection: null,
  addedConsentQuiz: null,
  addedOptionalConsentQuiz: null,
  schedulerObj: null,
  surveyQuestions: [],
  // is required
  clientId: null,
  signatureStatus: null,
  signatureData: null,
  cancelAssociationEditing: null,
  telehealthVisitObj: [],
  videoCallStatusValue: false,
  telehealthAppointmentDuration: null,
  participantsAppointmentStatus: null,
  staticUrl: "",
  isPublishDisabled: false,
  isPreviewDisabled: false,
  getIsRwebPreviewDisable: true,
  isPublishTab: false,
  activityRows: null,
  activityDetails: null,
  activityQuestions: [],
  newActivityQuestion: null,
  selectedActivityQuestion: null,
  lastModifiedActivityQuestion: null,
  base64SignatureData: null,
  base64InitialData: null,
  /** Participants Portal - START */
  participantsPortalGlobalElements: null,
  participantsPortalConfig: null,
  participantsPortalLangages: null,
  participantsPortalLangageTranslation: null,
  participantsPortalStrings: null,
  participantsPortalBitriseData: null,
  participantsPortalStudyData: null,
  participantsSelectedActivity: null,
  participantAdherences: null,
  participantTaskSchedules: null,
  participantStudyTaskSchedules: null,
  participantsLanguages: null,
  participantsStudyVideos: null,
  participantsCountries: null,
  participantsPortalConsentData: null,
  participantsPortalDetails: null,
  participantsTelehealthVideoCallDetails: null,
  participantsActivityTranslation: null,
  selectedActivity: null,
  /** Participants Portal - END */
  awsCognitoAuthentication: null,
  pwebCognitoAuthentication: null,
  activityCSSRLangages: null,
  ssoLoginURL: null,
  /** Dynamic Activity Scheduling - Start */
  constantDynamicActivitySchedulesData: null,
  dynamicActivitySchedulesData: null,
  editSelectedDynamicActivityScheduleData: null,
  /* Storing a particular Dynamic-schedule's "triggers ie. (1 of 3)" & "actions ie. (2 of 3)" page's data, during "add" or "edit" */
  configuredTriggersData: null,
  configuredActionsData: null,
  dynamicSchedulingService: null,
  /** Dynamic Activity Scheduling - End */
  isDateRangeEnabled: false,
  studyToggledFeatures: null,
  multiFactorAuthEnabled: null,
  siteDetailsData: null,
  webSocketServiceData: null
};
